import {routesPosition, RoutesProps} from "../router.config";
import React from "react";

const Dashboard = () => {

    return (
        <div></div>
    )
}

export const dashboardRoutes: RoutesProps = {
    path: '/',
    position: routesPosition.leftSideBar,
    name: 'Accueil',
    icon: 'fas fa-home',
    element: <Dashboard/>,
    index: true,
};
